module.exports = __webpack_public_path__ + "img/notifications/trim-331dba53763895786ebd76995a0c10fa.svg";